import React from 'react'
import { Container as BlockContainer } from '../Blocks'
import { Container, Row, Col } from 'reactstrap'
import { getAssetUrl } from '../../services/cdn'


class SavingsForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalOpen: false,
            modalTitle: '',
            modalDescription: '',
            modalBottomDescription: '',
            modalSrc: '',
            modalLink: '',
            modalAlt: ''
        }
    }
    toggle = () => {
        this.setState((state, props) => {
            return {
                isModalOpen: !state.isModalOpen
            }
        })
    }
    open = (data) => {
        this.setState({
            isModalOpen: true,
            modalTitle: data.title,
            modalDescription: data.description,
            modalBottomDescription: data.bottomDescription,
            modalSrc: data.src,
            modalAlt: data.alt,
            modalLink: data.link
        })
    }
    render() {
        return (
            <>
                <BlockContainer padding={0} className="pb-5">
                    <Container>
                        <Row>
                            <Col md="12" >
                                <h1 className="mb-3">Savings Form</h1>
                            </Col>
                            <Col md="12" >
                                <h3 className="mb-3">Depositors Data Card Form</h3>
                                {/*Thumbnail
                                <p align="center">
                                 <img className="img-fluid d-block pt-5" alt="Depositors Data Card Form" src={getAssetUrl('app/tmb_depositordataform.png')} class="center" />
                                 </p>*/}
                                <p>
                                  <a target="_blank" rel="noreferrer" href={getAssetUrl('../documents/DepositorsDataCard.pdf')}>
                                  <button class="btn btn-primary" >Download Form</button>
                                  </a>
                                </p>
                          </Col>
                          {/*Young Saver's Club Depositors Data Card Downloadable Form
                          <Col md="12" >
                              <h3 className="mb-3">Young Saver's Club Depositors Data Card Form</h3>
                               Thumbnail
                              <p align="center">
                                <img className="img-fluid d-block pt-5" alt="Young Saver's Club Depositors Data Card Form" src={getAssetUrl('app/tmb_youngsaversdepositorform.png')} class="center" />
                              </p>
                              <p>
                                <a target="_blank" rel="noreferrer" href={getAssetUrl('../documents/YSCDepositorsDataCard.pdf')}>
                                <button class="btn btn-primary" >Download Form </button>
                                </a>
                              </p>

                          </Col>*/}
                            <Col md="12" >
                                <h3 className="mb-3">Investment Form</h3>
                                {/*Thumbnail
                                <p align="center">
                                  <img className="img-fluid d-block pt-5" alt="Investment Form" src={getAssetUrl('app/tmb_investmentform.png')} class="center" />
                                </p>*/}
                                <p>
                                  <a target="_blank" rel="noreferrer" href={getAssetUrl('../documents/InvestmentForm.pdf')}>
                                  <button class="btn btn-primary" >Download Form </button>
                                  </a>
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </BlockContainer>
                </>
        )
    }
}

export default SavingsForm
